import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';
import { hasSomePermission } from 'unihow-common';
import { isUserLoggedIn } from '../../util';

import { routes } from '../../constants';

const redirectToRoute = (route) => (
  <Navigate
    to={route}
    replace
    state={{ referrer: window.location.pathname }}
  />
);

const redirectToLogin = () => redirectToRoute(routes.login);

const checkPermission = (currentUser, reqPermissions) => {
  if (!reqPermissions) {
    return true;
  }
  const usersPerms = currentUser.permissions;

  return hasSomePermission(usersPerms, reqPermissions);
};

const RequireAuth = ({
  permissions = null, redirectTo = `${routes.error}/403`
}) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const userPending = useSelector((state) => state.user.pending);

  if (userPending) {
    return null;
  }
  if (isUserLoggedIn(currentUser)) {
    return checkPermission(currentUser, permissions)
      ? <Outlet />
      : redirectToRoute(redirectTo);
  }
  return redirectToLogin();
};

export default RequireAuth;
